import { ParamMap } from '@angular/router';

import { SYSTEM_FOLDERS } from './models/inbox-list.models';

export function buildEmailsCommands(contractId: number, folderId: number, emailId?: number): (string | number)[] {
  const commands: (string | number)[] = ['emails', contractId, folderId];
  if (emailId != null) {
    commands.push(emailId);
  }
  return commands;
}

export function buildEmailsUrlPath(tenant: string, contractId: number, folderId: number, emailId?: number): string {
  const parts: (string | number)[] = [tenant, 'emails', contractId, folderId];
  if (emailId != null) {
    parts.push(emailId);
  }
  return parts.join('/');
}

export function parseEmailsRouteParams(paramMap: ParamMap): {
  contractId: number | null;
  folderId: number;
  emailId: number | null;
} {
  const contractIdRaw = paramMap.get('contractId');
  const folderIdRaw = paramMap.get('folderId');
  const emailIdRaw = paramMap.get('emailId');

  return {
    contractId: contractIdRaw != null && contractIdRaw !== '' ? parseInt(contractIdRaw, 10) : null,
    folderId: folderIdRaw != null && folderIdRaw !== '' ? parseInt(folderIdRaw, 10) : SYSTEM_FOLDERS.INBOX,
    emailId: emailIdRaw != null && emailIdRaw !== '' ? parseInt(emailIdRaw, 10) : null,
  };
}
